import { analyticsLocalStorage } from '.';

export default ({ blockTimes, chapterId, courseId, userId }) => {
  const existingEntry = analyticsLocalStorage.findExistingEntry({
    type: 'blockActivity',
    userId
  });

  const data = existingEntry ? existingEntry.values.data : {};

  const blockIds = Object.keys(blockTimes);
  for (let i = 0; i < blockIds.length; i++) {
    const blockId = blockIds[i];
    if (blockId in data) {
      data[blockId] += blockTimes[blockId];
    } else {
      data[blockId] = blockTimes[blockId];
    }
  }

  analyticsLocalStorage.createOrUpdateEntry({
    key: existingEntry ? existingEntry.key : null,
    values: {
      data,
      type: 'blockActivity',
      chapterId,
      courseId,
      userId
    }
  });
};
